import ServicePageTemplate from "../components/ServicePageTemplate";
import SEO from "../components/SEO";
import { BESKARNING_FAQS } from "../data/faqs";

export default function Beskarning() {
  return (
    <>
      <SEO
        title="Beskärning och trädvård i Laholm | Trädfällarna"
        description="Behöver du hjälp med beskärning eller trädvård i Laholm med omnejd? Trädfällarna hjälper till med trygg beskärning för friskare, säkrare och mer välformade träd."
        path="/beskarning"
      />
    <ServicePageTemplate
      eyebrow="Tjänst"
      title="Beskärning och trädvård"
      intro="Rätt beskärning gör trädet friskare, säkrare och mer välformat. Vi hjälper dig bedöma vad som bör tas bort, när arbetet bör göras och hur trädet bäst tas om hand framåt."
      heroImage="/images/hero-beskarning.webp"
      heroImagePosition="75% 50%"
      bodyHeading="Friskare träd och en tryggare trädgård"
      bodyText="Beskärning handlar om mer än utseende. Med rätt snitt vid rätt tid får trädet bättre balans, mindre risk för grenbrott och en sundare tillväxt. Vi anpassar arbetet efter art, säsong och trädets allmänna kondition."
      bullets={[
        "Bättre ljusinsläpp i trädgården",
        "Friskare träd genom rätt snitt",
        "Säkrare grenar nära hus och uppfart",
        "Bra form och balans i kronan",
        "Beskärning efter säsong och trädets behov",
      ]}
      faqId="beskarning-faq"
      faqTitle="Vanliga frågor om beskärning"
      faqItems={BESKARNING_FAQS}
    />
    </>
  );
}
